import axios from "./axios";

class ProfileService {
  fetch = async () => {
    try {
      const response = await axios.post("/profile/fetch", {});

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };

  updateBasic = async (name, email, gender) => {
    try {
      const response = await axios.post("/profile/update_basic", {
        name,
        email,
        gender,
      });

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };

  fetchBalance = async () => {
    try {
      const response = await axios.post("/profile/balance", {});

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };

  fetchEarningDetails = async () => {
    try {
      const response = await axios.post("/profile/fetch_earning_details", {});

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };

  getReferralCode = async () => {
    try {
      const response = await axios.post("/profile/get_referral_code", {});

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };

  fetchFlashMessage = async () => {
    try {
      const response = await axios.post("/profile/fetch_flash_message", {});

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };
}
export default new ProfileService();
